module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921102651_T.57135b6f.jpg";